module.exports = __webpack_public_path__ + "media/assets/icons/ic-checkbox-checked-a23ed66dedb376e0275e4fec9a0a34b2.svg";